<template>
  <div class="browser-open">
  </div>
</template>

<script>
export default {
    name:'browserOpen',
    // mounted() {
    //         var userAgent = navigator.userAgent.toLowerCase();

    //         // 判断是否在微信中打开
    //         if (userAgent.indexOf('micromessenger') !== -1) {
    //             console.log('当前页面在微信中打开');
    //         } else {
    //             console.log('当前页面不在微信中打开');
    //         }

    //     this.$router.push({
    //        path: 'diamondRecharge',
    //        query : {
    //             wxId:this.$route.query.code
    //        }
    //     })
    // }
}
</script>

<style lang="less" scoped>
    .browser-open {
        height: calc(100vh);
        background: url('/imgs/browser-open.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-attachment: fixed;
        z-index: 999;

    }
</style>
